import { ReactComponent as GoogleLogo } from '@findy-code/yuffie/shared/images/google-logo.svg';
import { Heading } from '@findy-code/yuffie/ui/heading';
import Link from 'next/link';
import { FaGithub } from 'react-icons/fa';

import jobDescriptionMaskBg from './images/job-description-mask-bg.png';
import jobDescriptionMaskBg2x from './images/job-description-mask-bg@2x.png';
import styles from './register.component.module.scss';

declare module 'csstype' {
  interface Properties {
    [index: `--${string}`]: string | number;
  }
}

type Props = {
  companyId: number;
  jobDescriptionHash: string;
  onClickLink?: (label: string) => void;
};

export const Register = ({
  companyId,
  jobDescriptionHash,
  onClickLink,
}: Props) => {
  const params = new URLSearchParams({
    r: `/companies/${companyId}/jobs/${jobDescriptionHash}`,
  });

  return (
    <div className="paywall">
      <div
        className={styles.contentBlock}
        style={{
          '--background-image': `url('${jobDescriptionMaskBg.src}')`,
          '--media-background-image': `url('${jobDescriptionMaskBg2x.src}')`,
        }}
      >
        <div className={styles.contentInnerBlock}>
          <div className={styles.registerLabelWrap}>
            <div className={styles.registerLabel}>1分で登録完了</div>
          </div>
          <Heading align="center" as="h2" font="heading-m">
            年収・労働条件・採用方法をご覧いただくには会員登録が必要です
          </Heading>
          <div>
            <p className={styles.registerDivider}>登録してスカウトを受けとる</p>
          </div>
          <div className={styles.linkWrap}>
            <Link
              className={styles.loginWithGithubLink}
              href={`/users/sign_in?${params.toString()}`}
              onClick={() => onClickLink?.('求人計測_業務マスク画像クリック')}
            >
              <FaGithub
                aria-hidden="true"
                className={styles.githubIcon}
                size="18px"
              />
              GitHubで新規登録/ログイン
            </Link>
            <Link
              className={styles.loginWithGoogleLink}
              href={`/users/sign_in?${params.toString()}`}
              onClick={() => onClickLink?.('求人計測_業務マスク画像クリック')}
            >
              <GoogleLogo aria-hidden="true" className={styles.googleIcon} />
              Googleで新規登録/ログイン
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
